<template>
    <div class="col-12 px-0">
        <multiselect
            :searchable=true :close-on-select=false
            :id="id" v-model="chosenValues" :options="availableValues"
            :multiple="true"
            :custom-label="valueName"
            :track-by="idField"
            :disabled="isDisabled"
            :placeholder="placeholder"
            :selectLabel="selectLabel"
            :selectedLabel="selectedLabel"
            :deselectLabel="deselectLabel"
            :limit="limit"
            :limit-text="limitTxt"
            group-values="options" group-label="label" :group-select="true"
            :selectGroupLabel="$lang('Wybierz wszystkie statusy')"
            :deselectGroupLabel="$lang('Usuń wszystkie statusy')"
        >

        </multiselect>
        <input v-for="chosenValue in chosenValues" :name="name + '[]'" :value="chosenValue[idField]" hidden>
    </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import {EventBus} from "../mixins/event-bus";

export default {
    name: "multiselect-blade",
    components: {Multiselect},
    props: {
        values: {
            type: Array,
            required: true
        },
        chosen_values: {
            type: Array,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        id: {
            type: String,
            required: true
        },
        placeholder: {
            type: String,
            required: true
        },
        selectLabel: {
            type: String,
            required: true
        },
        selectedLabel: {
            type: String,
            required: true
        },
        deselectLabel: {
            type: String,
            required: true
        },
        idField: {
            type: String,
            required: true
        },
        limit: {
            type: Number,
            default: 5
        },
        addNullOption: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            availableValues: [],
            chosenValues: [],
            isDisabled: false
        }
    },
    methods: {
        valueName({name, surname}) {
            if (surname) {
                return surname + ' ' + name;
            } else {
                return name;
            }
        },
        limitTxt(number) {
            return '+' + number;
        },
        loadOptions(available, chosen) {
            this.availableValues = available;
            this.chosenValues = [];
            let self = this;
            available.forEach(function (item) {
                if (chosen.filter(function (x) {
                    if (typeof x === 'object' && x !== null) {
                        return x[self.idField] == item[self.idField];
                    } else {
                        return x == item[self.idField];
                    }
                }).length > 0) {
                    self.chosenValues.push(item);
                }
            })
            if (this.addNullOption) {
                this.chosenValues.push({name: '-', id: 0})
            }

            this.availableValues = [
                {
                    label: this.$lang('Wszystkie'),
                    options: this.availableValues
                }
            ];
        },
    },
    created() {
        this.loadOptions(this.values, this.chosen_values);
        this.isDisabled = this.disabled;
    },
    mounted() {
        EventBus.$on('libraryChangeEventData', (result) => {
            let options = result[this.name];
            this.loadOptions(options, options);
        });
        EventBus.$on('fixedFiltersDisabled', (result) => {
            this.isDisabled = result.disabled;
        });
    }
}
</script>
